/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { COMPONENT_SERVICE } from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityItems.constants';
import { getComponentDetailsWithinSetPath } from '../Utilities/GetComponentDetailsWithinSetPath/GetComponentDetailsWithinSetPath';
import { getComponentPath } from '../Utilities/GetComponentPath/GetComponentPath';
import { getComponentSetPath } from '../Utilities/GetComponentSetPath/GetComponentSetPath';

/**
 * The paths for each screen.
 * @export
 */
export const screenPaths = {
  allComponents: `${COMPONENT_SERVICE.path}/all-components`,
  componentDetails: `${COMPONENT_SERVICE.path}/all-components${getComponentPath('/')}`,
  componentDetailsWithinSet: `${COMPONENT_SERVICE.path}/component-sets${getComponentDetailsWithinSetPath('/')}`,
  componentSetDetails: `${COMPONENT_SERVICE.path}/component-sets${getComponentSetPath(`/`)}`,
  componentSets: `${COMPONENT_SERVICE.path}/component-sets`,
  contentMatrixIdentifiers: `${COMPONENT_SERVICE.path}/content-matrix-identifiers`,
};
